<template>
  <div class="user-activity" style="height: 405px;">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="用户名"><el-input v-model="form.name" disabled="true"></el-input></el-form-item>
      <el-form-item label="手机号"><el-input v-model="form.phone" disabled="true"></el-input></el-form-item>
      <el-form-item label="用户邮箱"><el-input v-model="form.email" disabled="true"></el-input></el-form-item>
      <el-form-item label="所属部门"><el-input v-model="form.dept" disabled="true"></el-input></el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
        <el-button>取消</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          name: '',
          email: '',
          avatar: '',
          roles: []
        };
      }
    }
  },
  data() {
    return {
      form: {
        name: this.user.name,
        phone: this.user.phone,
        email: this.user.email,
        dept: this.user.deptName
      }
    };
  },
  methods: {
    onSubmit() {

    }
  }
};
</script>

<style lang="scss" scoped>
.user-activity {
  .user-block {
    .username,
    .description {
      display: block;
      margin-left: 50px;
      padding: 2px 0;
    }

    .username {
      font-size: 16px;
      color: #000;
    }

    :after {
      clear: both;
    }

    .img-circle {
      border-radius: 50%;
      width: 40px;
      height: 40px;
      float: left;
    }

    span {
      font-weight: 500;
      font-size: 12px;
    }
  }

  .post {
    font-size: 14px;
    border-bottom: 1px solid #d2d6de;
    margin-bottom: 15px;
    padding-bottom: 15px;
    color: #666;

    .image {
      width: 100%;
      height: 100%;
    }

    .user-images {
      padding-top: 20px;
    }
  }

  .list-inline {
    padding-left: 0;
    margin-left: -5px;
    list-style: none;

    li {
      display: inline-block;
      padding-right: 5px;
      padding-left: 5px;
      font-size: 13px;
    }

    .link-black {
      &:hover,
      &:focus {
        color: #999;
      }
    }
  }
}

.box-center {
  margin: 0 auto;
  display: table;
}

.text-muted {
  color: #777;
}
</style>
